import { db } from '../db/db';

export async function checkAndTriggerStreakReminder() {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;

  // Bugünün tarihini YYYY-MM-DD formatında alalım
  // Yerel saati dikkate alarak formatlayalım
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  const todayStr = `${year}-${month}-${day}`;

  // Bugün bildirim gönderildi mi kontrol edelim
  const lastSent = localStorage.getItem('lastStreakNotificationSent');
  if (lastSent === todayStr) return;

  // Saat akşam 19:00'dan (7 PM) sonra mı kontrol edelim
  const currentHour = now.getHours();
  if (currentHour < 19) return;

  try {
    // Bugün atanmış ders programı var mı sorgulayalım
    const todayTasks = await db.scheduleItems.where('assignedDate').equals(todayStr).toArray();
    if (todayTasks.length === 0) return;

    // Tamamlanmamış dersleri bulalım
    const incompleteTasks = todayTasks.filter(t => !t.isCompleted);
    if (incompleteTasks.length > 0) {
      // Bildirimi tetikleyelim
      new Notification('Bitmiyo', {
        body: `Bugün tamamlaman gereken ${incompleteTasks.length} ders kaldı! Serini kaybetmemek için çalışmaya başla 🔥`,
        icon: '/favicon.ico', // Projedeki favicon veya logo dosyası
        tag: 'streak-reminder'
      });
      
      // Bildirim gönderildi tarihini işaretleyelim
      localStorage.setItem('lastStreakNotificationSent', todayStr);
    }
  } catch (err) {
    console.error("Streak bildirim kontrol hatası:", err);
  }
}
